const styles = `:host{margin:.25rem 1rem;display:flex}`;export default styles;